<template>
  <div class="animated fadeIn upload" >
    <div class="ops container-custom" style="position:relative;">
      <div class="notification" :class="showPopup && 'active'">
        <div class="notification__icon">
          <img src="img/icon/tin.png" alt="">
        </div>
        <div class="notification__text">
          Your file is uploaded successfully
        </div>
        <div class="notification__close">

        </div>
      </div>
      <div class="notification" :class="showError && 'active'">
        <div class="notification__text" style="color: #ff767b;">
          {{error}}
        </div>
        <div class="notification__close">

        </div>
      </div>
      <div class="ops__wrapper">
        <div class="ops__header">
          <div class="ops__title" id="traffic">Upload file</div>
        </div>
        <div class="upload__tabs">
          <div class="upload__tab">
            <div class="upload__info">
              Please, upload CSV file up to 5 Mb of size
            </div>
            <div class="upload__dropzone" :class="fileAdded && 'hide'">
              <vue-dropzone
                  ref="myVueDropzone"
                  id="dropzone"
                  :options="dropzoneOptions"
                  @vdropzone-file-added="() => fileAdded = true"
                  @vdropzone-removed-file="fileRemove"
              />
            </div>
            <div class="upload__btn">
              <div class="btn-csv" :class="!fileAdded && 'disabled'" @click="onFormSubmit">Send</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading" v-if="loading">
      <b-spinner class="align-middle"></b-spinner>
      <strong>Loading...</strong>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import TabNavigation from "../base/TabNavigation";
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import JsonCSV from 'vue-json-csv'

export default {
  name: 'Upload',
  components: {
    TabNavigation,
    vueDropzone: vue2Dropzone,
    JsonCSV
  },
  data: function () {
    return {
      url: process.env.VUE_APP_RUBY_URL || 'https://devopstest.petehealth.com:8080',
      showError: false,
      error: '',
      fileAdded: false,
      showPopup: false,
      loading: false,
      dropzoneOptions: {
        url: ' ',
        thumbnailWidth: 250,
        maxFilesize: 5,
        autoProcessQueue: false,
        addRemoveLinks: true,
        maxFiles: 1,
        acceptedFiles: '.csv'
      },
      onFormSubmit: async () => {
        const url = `${this.url}/api/zipcodes`;
        this.showError = false;
        this.loading = true;
        const formData = new FormData();
        const files = this.$refs.myVueDropzone.getAcceptedFiles();
        formData.append("file", files[0]);

        try {
          const res = await this.$newpetehealthapi.post(`${url}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          });

          this.loading = false;

          if (!res.data) {
            this.error = 'No entries updated';
            this.showInfo();
          }
          if (res.data[0] && res.data[0].Error) {
            this.error = res.data[0].Error;
            this.showInfo(false);
          } else if (res.data.indexOf('Error') >= 0) {
            this.error = res.data;
            this.showInfo(false);
          } else {
            this.error = 'Updated Records';
            this.$refs.myVueDropzone.removeAllFiles();
            this.showInfo(true);
          }
        } catch (e) {
          this.loading = false;
          this.$refs.myVueDropzone.removeAllFiles();
        }
      }
    }
  },
  methods: {
    fileRemove() {
      this.fileAdded = false
    },
    showInfo(e) {
      if (e) {
        this.showPopup = true;
        setTimeout(() => {
          this.showPopup = false;
        }, 3000);
      } else {
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 3000);
      }
    },
    getDataAsCSV() {
    }
  }
}
</script>

<style lang="scss">
.upload {
  &__error {
    opacity: 0;
    transition: .3s;
    color: #ff767b;
    font-size: 14px;
    &.active {
      opacity: 1;
    }
  }
  &__btn {
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    .btn-csv {
      height: 35px;
      font-size: 18px;
      text-transform: none;
      font-weight: 300;
    }
  }
  &__tab {

  }
  &__info {
    font-size: 13px;
    font-weight: 400;
    color: #737b8f;
    margin: 20px 0 25px;
  }
  &__dropzone {
    &.hide {
      pointer-events: none;
      .dz-preview.dz-file-preview {
        pointer-events: auto;
      }
    }
  }
}

.notification {
  position: fixed;
  top: 96px;
  right: 50px;
  min-width: 424px;
  width: auto;
  box-shadow: 0 30px 40px rgba(28, 42, 68, 0.1);
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: .3s;
  opacity: 0;
  pointer-events: none;
  &.active {
    opacity: 1;
    pointer-events: auto;
  }
  &__icon {
    width: 28px;
    height: 28px;
    background-color: #66f1c8;
    border-radius: 50%;
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 16px;
    }
  }
  &__text {
    color: #737b8f;
    font-size: 13px;
    font-weight: 400;
  }
  &__close {

  }
}

.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255,255,255, .5);
}
</style>


